<background-modal [isLoading]="submitStatus === 'loading'">
  <div *ngIf="submitStatus === 'questionUser'">
    <h1 i18n>Register now for {{camp?.name}}</h1>
    <p *ngIf="camp?.websiteUrl" i18n>Further information about the camp can be found on our <a [href]="camp?.websiteUrl" target="_blank" rel="noopener">website</a>.</p>
    <h2 i18n>Were you already on a Camp last Year ?</h2>
    <button class="btn btn-primary yes-no-button" (click)="participantWithExistingUser()" i18n>YES</button>
    <button class="btn btn-primary yes-no-button" (click)="submitStatus = 'normal'" i18n>NO</button>
  </div>
  <form *ngIf="submitStatus === 'normal'" [formGroup]="form" (ngSubmit)="signUp()">
    <h1 i18n>Register now for {{camp?.name}}</h1>
    <p *ngIf="camp?.websiteUrl" i18n>Further information about the camp can be found on our <a [href]="camp?.websiteUrl" target="_blank" rel="noopener">website</a>.</p>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>First Name</mat-label>
          <input matInput i18n-placeholder placeholder="First Name" formControlName="firstName"
            autocomplete="given-name" />
          <mat-error i18n *ngIf="form.get('firstName')?.errors?.['required']">
            First Name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>Last Name</mat-label>
          <input matInput i18n-placeholder placeholder="Last Name" formControlName="lastName"
            autocomplete="family-name" />
          <mat-error i18n *ngIf="form.get('lastName')?.errors?.['required']">
            Last Name is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>Your Birthdate</mat-label>
          <input [min]="minDate" [max]="maxDate" matInput [matDatepicker]="picker" formControlName="birthdate"
            [disabled]="true" />
          <mat-hint i18n>MM/DD/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker [disabled]="false" startView="multi-year"></mat-datepicker>
          <mat-error i18n *ngIf="form.get('birthdate')?.errors?.['required']">
            Birthdate is required
          </mat-error>
        </mat-form-field>
        <mat-error i18n *ngIf="getParticipantAge() < getMinAge()">You must be at least {{getMinAge()}} Years
          old</mat-error>
      </div>
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>Chose your Gender</mat-label>
          <mat-select formControlName="gender">
            <mat-option i18n *ngFor="let gender of genders" [value]="gender">{gender, select, male {male} female
              {female} diverse {diverse}}</mat-option>
          </mat-select>
          <mat-error i18n *ngIf="form.get('gender')?.errors?.['required']">
            Gender is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="fill">
          <mat-label i18n>Email of the Participant</mat-label>
          <input matInput i18n-placeholder placeholder="email@example.com" formControlName="email"
            autocomplete="email" />
          <mat-error i18n *ngIf="form.get('email')?.errors?.['required']">
            Email is required
          </mat-error>
          <mat-error i18n *ngIf="form.get('email')?.errors?.['email']">
            Email is in the wrong format
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>Enter your password</mat-label>
          <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
            autocomplete="new-password"
            matTooltip="Durch die Anmeldung erhälst du Zugang zu unserem Onlineportal mit weiteren Informationen. Hierfür vergibst du dir in diesem Feld dein Passwort."
            touchGestures="on" />
          <button mat-icon-button type='button' matSuffix (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>
          <mat-error i18n *ngIf="form.get('password')?.errors?.['required']">
            Password is required
          </mat-error>
          <mat-error i18n *ngIf="form.get('password')?.errors?.['minlength']">
            Password is to short
          </mat-error>
          <mat-hint i18n>password for the online-portal</mat-hint>
        </mat-form-field>
      </div>
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>Phone number</mat-label>
          <input matInput i18n-placeholder placeholder="+49123456789" formControlName="phoneNumber" autocomplete="tel"
            type="tel" />
          <mat-error i18n *ngIf="form.get('phoneNumber')?.errors?.['required']">
            Phone number is required
          </mat-error>
          <mat-error i18n *ngIf="form.get('phoneNumber')?.errors?.['pattern']">
            Phone number has the wrong format
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field *ngIf="shouldShowParentEmail()" appearance="fill">
          <mat-label i18n>your Parents email</mat-label>
          <input matInput i18n-placeholder placeholder="parent@example.com" formControlName="parentEmail" />
          <mat-error i18n *ngIf="form.get('parentEmail')?.errors?.['required']">
            Email is required
          </mat-error>
          <mat-error i18n *ngIf="form.get('parentEmail')?.errors?.['email']">
            Email is in the wrong format
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <mat-divider></mat-divider>
    <h2 i18n>Address</h2>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="fill">
          <mat-label i18n>Street</mat-label>
          <input matInput i18n-placeholder placeholder="Street" formControlName="street"
            autocomplete="street-address" />
          <mat-error i18n *ngIf="form.get('street')?.errors?.['required']">
            Street is required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>City</mat-label>
          <input matInput i18n-placeholder placeholder="City" formControlName="city" autocomplete="home city" />
          <mat-error i18n *ngIf="form.get('city')?.errors?.['required']">
            City is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-sm-12 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label i18n>Postal code</mat-label>
          <input matInput i18n-placeholder placeholder="Postalcode" formControlName="postalCode"
            autocomplete="postal-code" type="number" inputmode="decimal" />
          <mat-error i18n *ngIf="form.get('postalCode')?.errors?.['required']">
            Zip code is required
          </mat-error>
          <mat-error i18n *ngIf="form.get('postalCode')?.errors?.['pattern']">
            Zip code must be 5 digits
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <mat-divider></mat-divider>
    <h2 i18n>Additional</h2>
    <div class="row">
      <div class="col-8">
        <mat-form-field appearance="fill">
          <mat-label i18n>Are you a Student?</mat-label>
          <mat-select formControlName="student">
            <mat-option i18n *ngFor="let student of students" [value]="student">{student, select, student {student}
              universityStudent {universityStudent} trainee {trainee}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="fill">
          <mat-label i18n>Comments</mat-label>
          <textarea matInput i18n-placeholder placeholder="Space for additional information"
            formControlName="comment"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <mat-checkbox id="dataProtection" formControlName="dataProtection" i18n>I Agree to the <a target="_blank"
            href="/privacy-policy">data protection.</a></mat-checkbox>
      </div>
    </div>
    <div class="row justify-content-end spacer">
      <div class="col-sm-12 col-md-3">
        <button class="btn btn-primary" type="submit" [disabled]="!form.valid" i18n style="width: 100%;"> Register
        </button>
      </div>
    </div>
  </form>
  <div class="row">
    <div *ngIf="submitStatus == 'success'" class="col-12">
        <h1 i18n>That worked</h1>
        <div>
            <span i18n>you will soon receive an Email. Please check your Spam folder.</span><br>
            <span i18n>If you didn't recived the Email, please contact</span> <a [href]="'mailto:freizeit@cjg-fn.de'" i18n i18n-href>freizeit&#64;cjg-fn.de</a>
        </div>
        <br><br>
        <div>
            <span i18n>We do need some more information from you. Either you <a [routerLink]="['/participant']" [queryParams]="{redirectToCamp: true}">login</a> now directly, or you do it later with the link in the Email.</span>
        </div>
    </div>
    <div *ngIf="submitStatus == 'error'" class="col-12">
        <h1 i18n>Something went wrong</h1>
        <h2 *ngIf="error">{{error}}</h2>
        <span i18n>Please try again later or contact an Administrator here:
        </span><a [href]="'mailto:info@cjg-fn.de'" i18n i18n-href>info&#64;cjg-fn.de</a>
    </div>
    <div *ngIf="submitStatus == 'error-email-exists'" class="col-12">
        <h1 i18n>User already exists</h1>
        <h2 i18n>It looks like you already have an account.</h2>
        <p i18n>you can <a routerLink="/participant">login</a> to your account.</p>
        <p i18n>or <a routerLink="/forgot-password">reset your password</a></p>
    </div>
    <div *ngIf="submitStatus == 'disabled'" class="col-12">
        <h1 i18n>Registration Disabled</h1>
    </div>
</div>
  <div class="row big-spacer">
    <div class="col-12">
      <span i18n>Already have an account?</span>&nbsp;
      <a class="no_default" routerLink="/sign-in" i18n>Log In</a>
    </div>
  </div>
</background-modal>